import { AppEnvironment } from './environment.model';

export const environment: AppEnvironment = {
  production: false,
  appName: 'Student Portal',
  apiBaseUrl: '',
  imageBaseUrl: 'assets',
  imageFallbackUrl: 'assets/images/placeholders/default-image.png',
  useMockData: true,
  enableStudentBillingLookup: true,
  enableStudentBillingMockDemo: true,
  enableStudentProfile: true,
  enableStudentProfileMockDemo: true,
};
